import React, { useEffect, useState } from 'react';
import "./ServicesSettingsList.scss"

import { useSelector, useDispatch } from 'react-redux';
import PostService from '../../../API/PostService';
import { useFetching } from '../../../hooks/useFetching';
import { setSettingsAction } from '../../../store/settingsReducer';
import ServicesSettingsItem from '../ServicesSettingsItem/ServicesSettingsItem';
import ServicesSettingsAdd from '../ServicesSettingsAdd/ServicesSettingsAdd';
const ServicesSettingsList = () => {
    const dispatch = useDispatch();
    const settings = useSelector(state => state.settings.settings)
    const clinic = useSelector(state => state.recordsTable.clinic)
    const [settingsList, setSettingsList] = useState([]);
    const clinics = useSelector(state => state.clinics.clinics)
    const [clinicAddress, setClinicAddress] = useState(null);
    useEffect(() => {
		if(clinic){
			fetchSettings(clinic);
			const clinicObj = clinics.find((el) => Number(el.id) === Number(clinic))
			if(clinicObj) setClinicAddress(clinicObj.address)
		}
	}, [clinic]);

    useEffect(() => {
		setSettingsList(settings);
	}, [settings]);

	const [fetchSettings] = useFetching(async (clinicId) => {
		const response = await PostService.getSettingsByClinic(clinicId)
		if (response.data.success && response.data.result !== false) {
			dispatch(setSettingsAction(response.data.result))
		}
	})
	return (
		<div className="services-settings-list">
            <div className="services-settings-list__headline">
                <h3>Настройки доступности</h3>
            </div>
			{clinicAddress &&
				<div className="services-settings-address">
					{clinicAddress}
				</div>
			}
            <div className="services-settings-list__content g-hide-scrollbar">
                {
                    settings.map((el) => {
                        return(
                            <ServicesSettingsItem element={el} key={el.id}/>
                        )
                    })
                }
                <ServicesSettingsAdd />
            </div>
		</div>
	);
};

export default ServicesSettingsList;
